import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import ApiUiController from '../../controller/ApiUiController';
import FieldDocumentType from '../common/FieldDocumentType';
import FieldText from '../common/FieldText';
import FieldFile from '../common/FieldFile';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import DocumentAPI from '../../api/DocumentAPI';
import ValidationController from '../../controller/ValidationController';
import FieldMultiValItem from '../common/FieldMultiValItem';
import Scroll from 'react-scroll';
import FieldTextArea from '../common/FieldTextArea';
class DocumentPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).document;
    const doc = {
      id: 0, file_type: 0, description: '', files: null,
      model_no: props.model_no, model_id: props.model_id, link: ''
    };
    this.state = { inApiCall: false, document: { ...doc }, inValid: {} };
    this.values = [''];
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.model_id !== this.props.model_id) {
      const doc = {
        id: 0, file_type: 0, description: '', files: null, link: '',
        model_no: props.model_no, model_id: props.model_id
      };
      this.setState({ ...this.state, document: { ...doc } });
    }
  }

  onValueChange = (field, value) => {

    const doc = this.state.document;
    doc[field] = value;
    this.setState({ ...this.state, document: { ...doc }, inValid: {} });
  };

  onSave = () => {
    // const inValid = ValidationController.validate(this.model.fields, this.state.document);
    // if (inValid === null) {
    this.setState({ ...this.state, inApiCall: true });
    this.values = [''];
    DocumentAPI.save(this.state.document, this.onSaved, this.onFail);
    // } else { this.setState({ ...this.state, inValid: { ...inValid } }); }
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Document saved successfully', 'success');
    const doc = {
      id: 0, file_type: 0, description: '', files: null,
      model_no: this.props.model_no, model_id: this.props.model_id, link: ''
    };
    this.setState({ inApiCall: false, document: { ...doc }, inValid: {} });
    this.props.onHide();
    if (this.props.reload) this.props.reload();

  };
  delete = index => {
    this.values = this.values.filter((_, i) => i !== index);
    const value = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.onValueChange('link', value);
    this.setState({ ...this.state, changed: !this.state.changed });
  };

  update = (index, val) => {
    this.values[index] = val;
    const value = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.onValueChange('link', value);
  };

  add = () => {
    this.values.push('');
    const value = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.onValueChange('link', value);
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;

    let valueList = [];
    for (let i = 0; i < this.values.length; i++) {
      valueList.push(
        <FieldMultiValItem key={`mul_${i}`} index={i}
          value={this.values[i]} add={this.add} delete={this.delete}
          onChange={this.update} validate={null} inValid={{}} />
      );
    }
    return (
      <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{this.props.title ? this.props.title : "Add Document"} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}>
              {!this.props.title ? <FieldDocumentType key="file_type" id="file_type" field={fields.file_type}
                value={this.state.document.file_type} onValueChange={this.onValueChange}
                model_no={this.props.model_no}
                inValid={inValid} /> :
                this.props.title && !this.props.title?.includes('Video') &&
                <FieldDocumentType key="file_type" id="file_type" field={fields.file_type}
                  value={this.state.document.file_type} onValueChange={this.onValueChange}
                  model_no={this.props.model_no}
                  inValid={inValid} />
              }
              <FieldTextArea key="description" id="description" field={fields.description}
                value={this.state.document.description} onValueChange={this.onValueChange}
                inValid={inValid} />
              {this.props.title && this.props.title?.includes('Video') && fields.link?.visible ?
                <div className="col contactinfodiv">
                  <Scroll.Element name={this.Key} />
                  <label>{fields.link.label_name} </label>
                  {valueList}
                </div> : null
              }
              <FieldFile key="files" id="files" field={fields.files}
                onValueChange={this.onValueChange} inValid={inValid} multiple={true} document_type={this.props.document_type} />
            </ApiUiController>
          </Form>
        </Modal.Body>
        <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
      </Modal >
    );
  }
}
export default DocumentPopup;